<i18n
  src="@/locales/views/agro_exporter/certifications/providers/show_organization.yml"
  lang="yaml"
></i18n>
<template>
  <div class="mt-8">
    <div class="flex flex-row justify-end">
      <new-button
        @click.prevent="goToNewCertificationReview"
        :label="$t('labels.new_certification_review_button')"
      />
    </div>
    <div class="mt-4 flex flex-col">
      <alert-danger :errors_data="std_err" />
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    Fecha de revisión
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="certification_review in certification_reviews"
                  :key="certification_review.id"
                >
                  <td class="table-cell">
                    {{ dateFormatter(certification_review.reviewed_at) }}
                  </td>
                  <td class="table-cell-action">
                    <destroy-button
                      v-if="!certification_review.proc_button_destroy"
                      :disabled_button="false"
                      @destroyEvent="
                        destroyCertificationReview(certification_review)
                      "
                      :label="$t('labels.destroy_button_label')"
                      :title="$t('labels.destroy_button_title_cr')"
                      :message="$t('labels.destroy_button_message_cr')"
                      :label_confirm="$t('labels.destroy_button_label_confirm')"
                    />
                    <destroy-button-processing
                      v-else
                      :label="$t('labels.destroy_button_label')"
                    />
                    <span class="space-actions"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RequesterCertificationReview from "@/views/agro_exporter/requesters/certifications/providers/manage_certification_review.js";

export default {
  name: "AECertificationsProviderCertificationReviews",
  data() {
    return {
      certification_reviews: this.certification_reviews_original,
    };
  },
  props: {
    agro_exporter_id: { required: true },
    provider_type: { required: true },
    provider_id: { required: true },
    certification_reviews_original: { type: Array, required: true }
  },
  methods: {
    async destroyCertificationReview(certification_review) {
      certification_review.proc_button_destroy = true;
      try {
        let response = await RequesterCertificationReview.destroy(
          this.agro_exporter_id,
          this.provider_type,
          this.provider_id,
          certification_review.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.certification_reviews.splice(
          this.certification_reviews.indexOf(certification_review),
          1
        );
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title
          });
        }
      }
      certification_review.proc_button_destroy = false;
    },
    goToNewCertificationReview() {
      this.$router.push({
        name: this.routeName("new_certification_review"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          provider_id: this.provider_id,
          provider_type: this.provider_type
        }
      });
    }
  },
};
</script>
